var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"watermark",rawName:"v-watermark"}],attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":_vm.keepAlive}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }